"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES_INFO_KEY = exports.ROUTES_STORE_NAME = void 0;
exports.ROUTES_STORE_NAME = "routeshistory";
exports.ROUTES_INFO_KEY = "info";
